import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './WarrantyHighlightSection.module.scss';

const HighlightSection = ({ highlightSectionData }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    // 根据设备类型获取对应的图片
    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const {
    image,
    text,
    buttonText,
    buttonUrl,
    isComingSoon,
    externalLink = false,
  } = highlightSectionData || {};

  // 处理Sitecore格式的图片数据
  const imageField = image;
  const imageUrl = getImageUrl(imageField);

  // 处理Sitecore格式的富文本数据
  const textContent = text || '';

  return (
    <div className={styles.container} data-aos="fade-up">
      <div className={styles.wrapper}>
        <img src={imageUrl} alt="Highlight background" className={styles.backgroundImage} />
        <div className={styles.container}>
          <div className={styles.containerText} dangerouslySetInnerHTML={{ __html: textContent }} />
          <div className={styles.containerLink}>
            {isComingSoon ? (
              <button className={styles.comingSoon}>Coming soon</button>
            ) : (
              <a
                className={styles.pcButton}
                href={buttonUrl}
                {...(externalLink ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              >
                {buttonText}
              </a>
            )}
          </div>
        </div>
      </div>

      {isComingSoon ? (
        <button className={styles.comingSoonMobile}>Coming soon</button>
      ) : (
        <a
          className={styles.laptopButton}
          href={buttonUrl}
          {...(externalLink ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        >
          {buttonText}
        </a>
      )}
    </div>
  );
};

export default HighlightSection;
